import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
// import placeholderImg from "../assets/images/new/Batuk2-removebg-preview.png";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
// import StupaImg from "../Images/stupa.jpg";
import "./ThankYou.css";
import { Link, Links } from "react-router-dom";

const ThankYou = () => {
  const location = useLocation();

  const navigate = useNavigate();

  console.log(location?.state?.paymentData, "dsds32222423");
  console.log(location?.state, "dsds32423");
  const HandleOrderPage = () => {
    if (location?.state?.moduleName === "PujaBooking") {
      navigate("/my-order-puja-booking");
    } else if (location?.state?.moduleName === "PrasadBooking") {
      navigate("/prasad-order");
    } else if (location?.state?.moduleName === "DailyPujaBooking") {
      navigate("/my-order-daily-Booking");
    } else if (location?.state?.moduleName === "MyStore") {
      navigate("/my-order");
    } else if (location?.state?.moduleName === "DarshanBooking") {
      navigate("/my-order-darshan-Booking");
    } else if (location?.state?.moduleName === "PujaAtTemple") {
      navigate("/my-order-puja-At-Temple");
    }
  };
  return (
    <div className="thank-you--order-main">
      <div className="">
        <div>
          <img
            src={placeholderImg}
            alt="404"
            className="error-404__image"
            style={{ height: "12em" }}
          />
        </div>
        {location?.state?.moduleName === null || location?.state?.moduleName === undefined ? (
          <h3 className="error-404__text">Thank you for visiting Myomnamo! </h3>
        ) : (
          <h3 className="error-404__text">{location?.state?.moduleName === 'PanditRegister' || location?.state?.moduleName === 'ContactUs' ? 'Thank you' : 'Thank you for your order!'}  </h3>
        )}
        {location?.state?.moduleName !== null && location?.state?.moduleName !== undefined ? (
          <div className="error-404__btns ">

            <button
              style={{ padding: "5px 16px", fontSize: "14px" }}
              onClick={() => {
                navigate("/");
              }}
              className="Normal-app-btn mx-3"
            >
              Home
            </button>
            {(location?.state?.moduleName !== 'PanditRegister' && location?.state?.moduleName !== 'ContactUs') && (
              <button
                style={{ padding: "5px 16px", fontSize: "14px" }}
                onClick={() => HandleOrderPage()}
                className="Normal-app-btn"
              >
                my order
              </button>
            )}

          </div>
        ) : <button
          style={{ padding: "5px 16px", fontSize: "14px" }}
          onClick={() => {
            navigate("/");
          }}
          className="Normal-app-btn mx-3"
        >
          Home
        </button>}

      </div>
    </div>
  );
};

export default ThankYou;
